export class DashboardWidget
{
    id: number;
    /** A fixed widget's slug, or the id of the custom form a widget counts. */
    key: string;
    image: string;
    total: number;
    title: string;
    shortTitle: string;
    url: string;
    rank: number;
    isEnabled: boolean;

    constructor(request: any) {
        this.id = request.id || null;
        this.key = request.key || null;
        this.image = request.image || null;
        this.total = request.total || 0;
        this.title = request.title || null;
        this.rank = request.rank || null;
        this.url = request.url || null;
        // The API sends 1/0, and `ph-switch` reads a boolean: a truthy 1 left every switch in
        // Manage Widgets drawn off while the widget was on.
        this.isEnabled = !!request.isEnabled;

        this.shortTitle = request.title && request.title.includes('Requests')
                ? request.title.split(' ')[0]
                : request.title;

    }
}
